import { render, staticRenderFns } from "./NotifyStep.vue?vue&type=template&id=0cb2ec90"
import script from "./NotifyStep.vue?vue&type=script&lang=ts"
export * from "./NotifyStep.vue?vue&type=script&lang=ts"
import style0 from "./NotifyStep.vue?vue&type=style&index=0&id=0cb2ec90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports